import { TrendingSortFilters } from "../Constants";
const initialState = {
  data: [],
  data2:[],
  pageNo: 0,
  sortFilter: TrendingSortFilters[0],
  sortOrder: TrendingSortFilters[0],
  sortChange: false,
  domains: [],
  isLoading: false,
  totalCount: 0,
  refresh: "refreshed",
  reloadPage: "random",
  searchQuery: "",
  AllScrolledAnswerUuid: [],
  answerUuidSentToUpdateViewCount: [],
  expertIndex: 0,
  threadIndex: 0,
  searchIndex: 0,
  viewIndex: 0,
  acceptedIndex: 0,
  loadMore: true,
  seekerAttachments:[],
  isRelevence:false,
  keytagsData:{},
  indexes:{
    0:{
      expertIndex: 0,
      threadIndex: 0,
      searchIndex: 0,
      viewIndex: 0,
      acceptedIndex: 0,
    }
  },
  isNext:true
};

const trendingReducers = (state = initialState, { type, payload }) => {
  switch (type) {
    case "trendingdataloading":
      state = { ...state, isLoading: payload };
      return state;
    case "trendingData":
      let newData = [];
      if (state.pageNo === 0) {
        newData = payload;
        state = { ...state, AllScrolledAnswerUuid: [] };
        state = { ...state, answerUuidSentToUpdateViewCount: [] };
      } else {
        newData = state.data.concat(payload);
      }

      state = { ...state, data: newData, data2:payload, isNext:payload.length===0?false:true };
      return state;
    case "trendingDataTotalCount":
      state = { ...state, totalCount: payload };
      return state;
    case "trendingDataSelectedDomain":
      state = { ...state, data: [], data2:[] };
      state = { ...state, domains: payload };
      state = { ...state, sortChange: true };
      state = { ...state, pageNo: 0 };
      state = { ...state, AllScrolledAnswerUuid: [] };
      state = { ...state, answerUuidSentToUpdateViewCount: [] };
      return state;
    case "trendingDataSelectedSortingfilter":
      state = { ...state, data: [],data2:[] };
      state = { ...state, sortFilter: payload };
      state = { ...state, sortOrder: payload };
      state = { ...state, sortChange: true };
      state = { ...state, pageNo: 0 };
      state = { ...state, AllScrolledAnswerUuid: [] };
      state = { ...state, answerUuidSentToUpdateViewCount: [] };
      return state;
    case "trendingDataPageUpdate":
      if (payload === 0) {
        state = { ...state, pageNo: payload };
        state = { ...state, data: [],data2:[] };
        state = { ...state, AllScrolledAnswerUuid: [] };
        state = { ...state, answerUuidSentToUpdateViewCount: [] };
      } else {
        state = { ...state, pageNo: payload };
      }
      state = { ...state, sortChange: false,reloadPage:Math.random()*10 };
      return state;
    case "forcefullyemptydata":
      state = { ...state, data: [],data2:[] };
      return state;
    case "refreshTrendingData":
      state = { ...state, refresh: "refreshed" };
      return state;
    case "updateTrendingData":
      state = { ...state, data: payload, data2:payload };
      return state;
    case "reloadTrendingPage":
      state = { ...state, reloadPage: payload };
      return state;
    case "AllScrolledAnswerUuid":
      state = { ...state, AllScrolledAnswerUuid: payload };
      return state;
    case "answerUuidSentToUpdateViewCount":
      state = { ...state, answerUuidSentToUpdateViewCount: payload };
      return state;
    case "trendingSearchQuery":
      state = { ...state, searchQuery: payload };
      return state;
    case "markedTrendingData":
      state = { ...state, data: payload };
      return state;
    case "allAnswerUuidEmptyForScrollCount":
      state = { ...state, AllScrolledAnswerUuid: [] };
      return state;
    case "isTrendingLoadMore":
      state = { ...state, expertIndex: payload[0] };
      state = { ...state, threadIndex: payload[1] };
      state = { ...state, searchIndex: payload[2] };
      state = { ...state, viewIndex: payload[3] };
      state = { ...state, acceptedIndex: payload[4] };
      state = { ...state, loadMoreloadMore: payload[5] };
      return state;
    case "getSeekerAttachmentsInTrending": 
    state = {...state, seekerAttachments:payload}
    return state;
    case "updateIsRelevanceTrendingData":
      state = { ...state, isRelevence: payload };
      return state;
    case "updateKeytagsData":
      state = { ...state, keytagsData: payload };
      return state;
    case "updateTrendingIndex":
      state = { ...state, indexes: payload };
      return state;
    default:
      return state;
  }
};

export default trendingReducers;
